export const UI_ELEMENTS = {
    DEFAULT_TOP_HEADER: 'default-top-header',
    TOOLS_HEADER: 'tools-header',
    PAGE_NAV_FLOATING_HEADER: 'page-nav-floating-header',
    DOWNLOAD_BUTTON: 'downloadButton',
    NOTES_PANEL: 'notesPanel',
    NOTES_PANEL_HEADER: 'notesPanelHeader',
} as const;

export type UIElementKey = keyof typeof UI_ELEMENTS;
export type UIElementValue = (typeof UI_ELEMENTS)[UIElementKey];
